var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9589 65.0612H38.0541C35.5922 65.0612 33.5779 63.1275 33.5779 60.764V39.2783H26.4608C22.477 39.2783 20.5075 34.6374 23.3275 31.9302L43.8732 12.2063C44.7095 11.4017 45.8449 10.9495 47.0289 10.9495C48.2129 10.9495 49.3483 11.4017 50.1846 12.2063L70.7303 31.9302C73.5503 34.6374 71.536 39.2783 67.5522 39.2783H60.4351V60.764C60.4351 63.1275 58.4208 65.0612 55.9589 65.0612ZM73.8575 73.6559H20.1432C17.6813 73.6559 15.667 75.5896 15.667 77.953C15.667 80.3164 17.6813 82.2502 20.1432 82.2502H73.8575C76.3194 82.2502 78.3337 80.3164 78.3337 77.953C78.3337 75.5896 76.3194 73.6559 73.8575 73.6559Z",
    fill: "#555893"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file_upload.044d4b47.svg";
export { ForwardRef as ReactComponent };